"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _TimezoneTypes = _interopRequireDefault(require("../constants/TimezoneTypes"));

var _formatShortDate = _interopRequireDefault(require("../utils/formatShortDate"));

var _formatMediumDate = _interopRequireDefault(require("../utils/formatMediumDate"));

var _formatShortMonthYear = _interopRequireDefault(require("../utils/formatShortMonthYear"));

var _formatMediumMonthYear = _interopRequireDefault(require("../utils/formatMediumMonthYear"));

var extraFormats = {
  'short-date': _formatShortDate.default,
  'medium-date': _formatMediumDate.default,
  'short-m-y': _formatShortMonthYear.default,
  'medium-m-y': _formatMediumMonthYear.default
};

var _default = _react.default.createClass({
  displayName: "FormattedDateTime",
  propTypes: {
    format: _react.PropTypes.string,
    type: _react.PropTypes.oneOf([_TimezoneTypes.default.PORTAL, _TimezoneTypes.default.USER, _TimezoneTypes.default.UTC]),
    value: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.number, _react.PropTypes.array]).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      type: _TimezoneTypes.default.PORTAL
    };
  },
  render: function render() {
    var _this$props = this.props,
        value = _this$props.value,
        format = _this$props.format,
        type = _this$props.type;
    var specialFormatter = extraFormats[format];
    var date = '';

    if (specialFormatter) {
      date = specialFormatter(value, type);
    } else {
      date = _I18n.default.moment[type](value).format(format);
    }

    return _react.default.createElement("span", null, date);
  }
});

exports.default = _default;
module.exports = exports.default;